// 화면에 보이는 웹 버전 (메뉴·설정에서 같은 값). 빌드할 때 REACT_APP_BUILD_DATE=YYYY.MM.DD 를 주면 그 날짜로 표시.
// 10/10 품질 점검: 메뉴 v1.2.1, 설정 v1.205.12346 으로 서로 달라 하나로 맞춤.
export const WEB_VERSION = `v${process.env.REACT_APP_BUILD_DATE || '2026.10.10'}`;
